// profileApi.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const updateProfile = async ({ name, email }) => {
  const response = await axios.put(`${API_BASE_URL}/profile`, { name, email });
  return response.data;
};

export const changePassword = async ({ currentPassword, newPassword, email }) => {
  const response = await axios.put(`${API_BASE_URL}/profile/password`, {
    currentPassword,
    newPassword,
    email
  });
  return response.data;
};

export const deleteAccount = async ({ email }) => {
  const response = await axios.delete(`${API_BASE_URL}/profile`, { data: { email } });
  return response.data;
};

